import React from 'react';
import Good1 from '../../../public/images/good1.webp';
import Good2 from '../../../public/images/good2.webp';
import Bad6 from '../../../public/images/good3.jpeg';
import Bad1 from '../../../public/images/bad1.jpeg';
import Bad2 from '../../../public/images/bad2.jpeg';
import Bad4 from '../../../public/images/bad4.jpeg';
import Bad5 from '../../../public/images/bad5.jpeg';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface PhotoGuidelinesModalAnonymizeProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ExampleImageProps {
  src: string;
  alt: string;
  caption: string;
  isBad?: boolean;
}

const ExampleImage: React.FC<ExampleImageProps> = ({ src, alt, caption, isBad = false }) => (
  <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
    <img
      src={src}
      alt={alt}
      className={`w-full h-52 object-cover bg-gray-50 ${isBad ? 'opacity-70' : ''}`}
    />
    <p className="p-2 text-sm text-center text-gray-600 bg-gray-50">
      {caption}
    </p>
  </div>
);

const PhotoGuidelinesCreateNeofaceModal: React.FC<PhotoGuidelinesModalAnonymizeProps> = ({
   isOpen,
   onClose
 }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-50"
    >
      <DialogBackdrop className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b">
            <Dialog.Title className="text-xl font-semibold">
              Guidelines
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-4 overflow-y-auto relative">
            {/* Good Examples Section */}
            <div className='mb-10'>
              <h3
                className='inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-sm font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10 mb-2'>
                Good Examples
              </h3>
              <div className='grid md:grid-cols-2 gap-4 mb-6'>
                <ExampleImage
                  src={Good1}
                  alt='Front facing example'
                  caption='Front Facing and Well Lit'
                />
                <ExampleImage
                  src={Good2}
                  alt='Nothing covering face example'
                  caption='Nothing Covering Face'
                />
              </div>
            </div>

            {/* Bad Examples Section */}
            <div>
              <h3
                className='inline-flex items-center rounded-md bg-pink-50 px-2 py-1 text-sm font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10 mb-2'>
                Bad Examples
              </h3>
              <div className='grid md:grid-cols-2 gap-4'>
                <ExampleImage
                  src={Bad1}
                  alt='No partial face example'
                  caption='No Partial Face'
                  isBad
                />
                <ExampleImage
                  src={Bad2}
                  alt='No profile view example'
                  caption='No Profile View'
                  isBad
                />
                <ExampleImage
                  src={Bad4}
                  alt='Too far away example'
                  caption='Too Far Away'
                  isBad
                />
                <ExampleImage
                  src={Bad5}
                  alt='Blurry Image'
                  caption='Blurry Image'
                  isBad
                />
                <ExampleImage
                  src={Bad6}
                  alt='Clear image example'
                  caption='Too Close'
                  isBad
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className='p-4 border-t bg-gray-50 flex justify-start'>
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-md bg-gray-600 hover:bg-gray-700 text-white"
            >
              Got it
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default PhotoGuidelinesCreateNeofaceModal;
